import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    homepage: [],
    projects: [],
    homepageImages: [],
    infoPage: [],
    metaInformation: []
  },
  mutations: {
    SAVE_PROJECTS (state, results) {
      state.projects = results;
    },
    SAVE_HOMEPAGE (state, results) {
      state.homepage = results;
    },
    SAVE_HOMEPAGE_IMAGES (state, images) {
      state.homepageImages = images;
    },
    SAVE_INFO_PAGE (state, info) {
      state.infoPage = info;
    },
    SAVE_META_INFORMATION (state, meta) {
      state.metaInformation = meta;
    }
  },
  getters: {
    randomProject: state => {
      var randomIndex = Math.floor(Math.random() * state.projects.length);

      return { project: state.projects[randomIndex], index: randomIndex };
    },
    hasPhotos: state => {
      return (state.projects.length > 0);
    }
  },
  actions: {
    async fetchProjects (context, {vm, cb}) {
      if (this.state.projects.length == 0) {
        await vm.$prismic.client.query(
          vm.$prismic.Predicates.at('document.type', 'project'), { pageSize : 100, orderings : '[order]' }
        ).then((response) => {
          // response is the response object, response.results holds the documents

          // console.log(response.results);

          // find and store images to be shown in the homepage
          var homepageImages = [];
          for (var project_index in response.results) {
            // console.log(response.results[project_index].data.body);
            if (response.results[project_index].data.body.length > 0) { //there are images for this project
              for (var image_index in response.results[project_index].data.body[0].items) {
                if (( response.results[project_index].data.body[0].items[image_index].is_video == false ||
                      response.results[project_index].data.body[0].items[image_index].is_video == null) &&
                    response.results[project_index].data.body[0].items[image_index].add_to_homepage == true) {
                  //save project uid to know where to go when clicked
                  response.results[project_index].data.body[0].items[image_index].uid = response.results[project_index].uid;
                  //push homepage image to store state array
                  homepageImages.push(response.results[project_index].data.body[0].items[image_index]);
                }
              }
            }
          }

          context.commit('SAVE_HOMEPAGE_IMAGES', homepageImages);

          context.commit('SAVE_PROJECTS', response.results);

          cb(response.results);
        })
      }
      else {
        cb(this.state.projects);
      }

      // context.commit('SAVE_PROJECTS', mock_data);
      // cb(mock_data);
    },
    async fetchHomepage (context, {vm, cb}) {
      if (this.state.projects.length == 0) {
        await vm.$prismic.client.query(
          vm.$prismic.Predicates.at('document.type', 'homepage'), { pageSize : 100, orderings : '[order]' }
        ).then((response) => {
          // response is the response object, response.results holds the documents

          // console.log(response.results);

          // find and store images to be shown in the homepage

          // var prismic_homepage_images = response.results[0].data.body[0].items;
          var prismic_homepage_images_groups = response.results[0].data.body;

          var homepageImages = [];

          for (var homepage_group_index in prismic_homepage_images_groups) {

            var prismic_homepage_images = prismic_homepage_images_groups[homepage_group_index].items;

            for (var homepage_index in prismic_homepage_images) {
              // console.log(response.results[project_index].data.body);

              var hover_text = (prismic_homepage_images[homepage_index].hover_text == null) ? '' : prismic_homepage_images[homepage_index].hover_text;
              var img_url = prismic_homepage_images[homepage_index].image.url;

              var horizontal = false;
              if (prismic_homepage_images[homepage_index].image.dimensions.width > prismic_homepage_images[homepage_index].image.dimensions.height) {
                horizontal = true;
              }

              var square = false;
              if (prismic_homepage_images[homepage_index].image.dimensions.width == prismic_homepage_images[homepage_index].image.dimensions.height) {
                square = true;
              }

              // var horizontal = prismic_homepage_images[homepage_index].horizontal;

              homepageImages.push({'hover_text' : hover_text, 'img_url': img_url, 'horizontal': horizontal, 'square': square});

              // if (response.results[homepage_index].data.body.length > 0) { //there are images for this project
              //   for (var image_index in response.results[homepage_index].data.body[0].items) {
              //     if (( response.results[homepage_index].data.body[0].items[image_index].is_video == false ||
              //           response.results[homepage_index].data.body[0].items[image_index].is_video == null) &&
              //         response.results[homepage_index].data.body[0].items[image_index].add_to_homepage == true) {
              //       //save project uid to know where to go when clicked
              //       response.results[homepage_index].data.body[0].items[image_index].uid = response.results[homepage_index].uid;
              //       //push homepage image to store state array
              //       homepageImages.push(response.results[homepage_index].data.body[0].items[image_index]);
              //     }
              //   }
              // }
            }
          }

          // for (var homepage_index in prismic_homepage_images) {
          //   // console.log(response.results[project_index].data.body);


          //   var hover_text = (prismic_homepage_images[homepage_index].hover_text == null) ? '' : prismic_homepage_images[homepage_index].hover_text;
          //   var img_url = prismic_homepage_images[homepage_index].image.url;

          //   homepageImages.push({'hover_text' : hover_text, 'img_url': img_url});

          //   // if (response.results[homepage_index].data.body.length > 0) { //there are images for this project
          //   //   for (var image_index in response.results[homepage_index].data.body[0].items) {
          //   //     if (( response.results[homepage_index].data.body[0].items[image_index].is_video == false ||
          //   //           response.results[homepage_index].data.body[0].items[image_index].is_video == null) &&
          //   //         response.results[homepage_index].data.body[0].items[image_index].add_to_homepage == true) {
          //   //       //save project uid to know where to go when clicked
          //   //       response.results[homepage_index].data.body[0].items[image_index].uid = response.results[homepage_index].uid;
          //   //       //push homepage image to store state array
          //   //       homepageImages.push(response.results[homepage_index].data.body[0].items[image_index]);
          //   //     }
          //   //   }
          //   // }
          // }

          // console.log(homepageImages);

          context.commit('SAVE_HOMEPAGE_IMAGES', homepageImages);

          context.commit('SAVE_HOMEPAGE', response.results);

          cb(response.results);
        })
      }
      else {
        cb(this.state.projects);
      }

      // context.commit('SAVE_PROJECTS', mock_data);
      // cb(mock_data);
    },
    async fetchInfoPage (context, {vm, cb}) {
      if (this.state.infoPage.length == 0) {
        await vm.$prismic.client.query(
          vm.$prismic.Predicates.at('document.type', 'info_page'), { pageSize : 100}
        ).then((response) => {
          // response is the response object, response.results holds the documents

          // console.log(response.results);

          context.commit('SAVE_INFO_PAGE', response.results);

          cb(response.results);
        })
      }
      else {
        cb(this.state.infoPage);
      }

      // context.commit('SAVE_PROJECTS', mock_data);
      // cb(mock_data);
    },
    async fetchHomepageImages(context, {vm, cb}) {
      cb(this.state.homepageImages);
    },
    async fetchMetaInformation (context, {vm, cb}) {
      if (this.state.metaInformation.length == 0) {
        await vm.$prismic.client.query(
          vm.$prismic.Predicates.at('document.type', 'meta_information'), { pageSize : 100}
        ).then((response) => {
          // response is the response object, response.results holds the documents

          // console.log(response.results);

          context.commit('SAVE_META_INFORMATION', response.results);

          cb(response.results);
        })
      }
      else {
        cb(this.state.metaInformation);
      }

      // context.commit('SAVE_PROJECTS', mock_data);
      // cb(mock_data);
    },
  }
})
